import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import axios from 'axios'

Vue.use(Vuex)

axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')

axios.interceptors.response.use(null, (error) => {
  if (error.response.status === 401) {
    localStorage.removeItem('token')
    axios.defaults.headers.common['Authorization'] = ''
    window.location.reload()
    return null
  }
  return Promise.reject(error)
})

const store = new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  strict: false
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js